import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScanPro = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_612_1812)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M22.1637 3.76254e-06H19.8247C19.1888 3.76254e-06 18.6665 0.522307 18.6665 1.15815C18.6665 1.794 19.1888 2.31631 19.8247 2.31631H22.1637C24.0939 2.31631 25.6608 3.88322 25.6608 5.81347V8.15248C25.6608 8.78832 26.1831 9.31063 26.819 9.31063C27.4548 9.31063 27.9771 8.78832 27.9771 8.15248V5.81347C27.9771 2.58881 25.3656 -0.0227051 22.141 -0.0227051L22.1637 3.76254e-06Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.15815 9.33332C1.794 9.33332 2.3163 8.81102 2.3163 8.17517V5.83616C2.3163 3.90591 3.88321 2.339 5.81346 2.339H8.15247C8.78832 2.339 9.31062 1.8167 9.31062 1.18085C9.31062 0.545003 8.78832 0.0226995 8.15247 0.0226995H5.81346C2.61152 -9.36352e-06 0 2.61151 0 5.83616V8.17517C0 8.81102 0.522303 9.33332 1.15815 9.33332Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.819 18.6667C26.1831 18.6667 25.6608 19.189 25.6608 19.8248V22.1638C25.6608 24.0941 24.0939 25.661 22.1637 25.661H19.8247C19.1888 25.661 18.6665 26.1833 18.6665 26.8191C18.6665 27.455 19.1888 27.9773 19.8247 27.9773H22.1637C25.3883 27.9773 27.9998 25.3658 27.9998 22.1411V19.8021C27.9998 19.1663 27.4775 18.644 26.8417 18.644L26.819 18.6667Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.17542 25.661H5.83641C3.90616 25.661 2.33925 24.0941 2.33925 22.1638V19.8248C2.33925 19.189 1.81695 18.6667 1.1811 18.6667C0.545252 18.6667 0.0229492 19.189 0.0229492 19.8248V22.1638C0.0229492 25.3885 2.63447 28 5.85912 28H8.19813C8.83398 28 9.35628 27.4777 9.35628 26.8418C9.35628 26.206 8.83398 25.6837 8.19813 25.6837L8.17542 25.661Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.8191 12.8305H22.1638V4.67801H5.83617V12.8305H1.15815C0.522303 12.8305 0 13.3528 0 13.9886C0 14.6245 0.522303 15.1468 1.15815 15.1468H5.81346V23.322H22.1411V15.1468H26.7964C27.4323 15.1468 27.9546 14.6245 27.9546 13.9886C27.9546 13.3528 27.4323 12.8305 26.7964 12.8305H26.8191ZM6.99432 5.83616H20.983V12.8305H6.99432V5.83616ZM20.983 22.1638H6.99432V15.1695H20.983V22.1638Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_612_1812",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 28,
			height: 28,
			fill: "white"
		})
	}) })]
});
export default SvgScanPro;
